import React, { useState } from "react";
import Part1 from "../1/Part1";
import Part2 from "../2/Part2";
import Part3 from "../3/Part3";
import Part4 from "../4/Part4";
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';

import { Scrollbar } from "react-scrollbars-custom";

const Next = ({ click }) => {
    const [page, setPage] = useState(1);
	const nextPage = () => {
		if (page < 4) setPage(page + 1);
	};
	const previousPage = () => {
		if (page > 1) setPage(page - 1);
	};

	const rumus = () => {
		if (page === 1) {
			return <Part1 />;
		}else if (page === 2){
			return <Part2 />
		}
		else if (page === 3){
			return <Part3 />
		}
		 else {
			return <Part4 />;
		} 
	};
   
    return (
        <div className="container-fluid">
            	<div
				style={{
					display: "flex",
					marginLeft:'5px',
					justifyContent: click ? "flex-end" : "center",
					textAlign:'justify',
					transition:"all 1.0s ease;"
					
				}}
			>
				
				<Scrollbar
					style={
						click
							? { width: "85%", height: 600 }
							: { width: "100%", height: 600 }
					
						}
				>
					{rumus()}
				</Scrollbar>
			</div>
            <div className="row d-flex justify-content-center align-items-center">
				<div className="col-lg-10 mb-1  ">
					<div
						style={{
							marginTop: "1rem",
							display: "flex",
                            justifyContent: "space-between",
                            // width: click ? "50%" : "100%",
						
						}}
					>
						<button
							className="btn btn-success"
							onClick={() => previousPage()}
							disabled={page === 1 ? true : false}
						>
							<SkipPreviousIcon />
						</button>
						<button
							className="btn btn-success"
							onClick={() => nextPage()}
							disabled={page === 4 ? true : false}
						>
							<SkipNextIcon />
						</button>
					</div>
				</div>
			</div>
        </div>
    )
}

export default Next
